import React, { memo } from 'react';

import Icon from '@components/icon-component';

import style from './style.module.scss';

const StartAndQuickCompleteButton = ({
  checkedLength,
  startBtnEvent,
  quickCheckedLength,
  quickBtnEvent,
  additionalDataLength,
  isDisabledAdditionalDataBtn = false,
  startDownloadingDataEvent
}) => {
  const quickCheckedLengthCondition =
    quickCheckedLength > 0 && checkedLength > 0 && checkedLength === quickCheckedLength;

  const additionalDataCHip = checkedLength > 0 && additionalDataLength > 0 ? true : false;
  return (
    <>
      {additionalDataCHip > 0 && (
        <button
          className={`${style.startBtn} ${
            isDisabledAdditionalDataBtn ? style.disabledAdditionalDataBtn : style.additionalDataBtn
          }`}
          onClick={startDownloadingDataEvent}
          style={{
            bottom: checkedLength > 0 && quickCheckedLengthCondition > 0 ? '174px' : '104px'
          }}
          // disabled={isDisabledAdditionalDataBtn}
        >
          <Icon name={'download-icon-gray-large'} /> Get additional data ({additionalDataLength})
        </button>
      )}

      {checkedLength > 0 && (
        <button
          className={style.startBtn}
          onClick={startBtnEvent}
          style={{
            bottom: quickCheckedLengthCondition > 0 ? '102px' : '32px'
          }}
        >
          <Icon name={'forward-icon'} /> Start ({checkedLength})
        </button>
      )}

      {quickCheckedLengthCondition && (
        <button className={style.quickComplete} onClick={quickBtnEvent}>
          <Icon name={'forward-icon'} /> Quick Complete ({quickCheckedLength})
        </button>
      )}
    </>
  );
};
export default memo(StartAndQuickCompleteButton);
